import React from "react";
import useVABondRetrieve from "./hooks/useVABondRetrieve";
import { BOND_RETRIEVE_PAGE_SECTIONS } from "./bondRetrievePageSections";
import { BondRetrievalShell } from "./components/bondRetrieval/BondRetrievalShell";

const VermostVABondRetrieveForm = () => {
  const hookState = useVABondRetrieve();
  const sectionConfig = BOND_RETRIEVE_PAGE_SECTIONS.va;
  const pageCtx = {
    globalState: hookState.globalState,
    updateGlobalState: hookState.updateGlobalState,
    role: hookState.role,
    disabled: hookState.disabled,
    data: hookState.data,
    userdetails: hookState.userdetails,
    bond_id: hookState.bond_id,
  };

  return (
    <BondRetrievalShell
      kind="va"
      sectionConfig={sectionConfig}
      pageCtx={pageCtx}
      onSubmitDataCorrection={hookState.handleSubmitDataCorrection}
      formatCorrectionFieldLabel={hookState.formatCorrectionFieldLabel}
      formatCorrectionFromTo={hookState.formatCorrectionFromTo}
      {...hookState}
    />
  );
};

export default VermostVABondRetrieveForm;
